/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FC, SVGProps } from 'react';

const ChatAnalyticsError: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <g id="surface67213779">
        <path
          css={css`
            stroke: none;
            fill-rule: nonzero;
            fill: ${props.fill || 'rgb(160, 15, 15)'};
            fill-opacity: 1;
          `}
          d="M 12 2 C 6.476562 2 2 6.476562 2 12 C 2 17.523438 6.476562 22 12 22 C 17.523438 22 22 17.523438 22 12 C 22 6.476562 17.523438 2 12 2 Z M 12 4 C 16.417969 4 20 7.582031 20 12 C 20 16.417969 16.417969 20 12 20 C 7.582031 20 4 16.417969 4 12 C 4 7.582031 7.582031 4 12 4 Z M 11 7 L 11 13 L 13 13 L 13 7 Z M 11 15 L 11 17 L 13 17 L 13 15 Z M 11 15 "
        />
      </g>
    </svg>
  );
};

export default ChatAnalyticsError;
